import { render, staticRenderFns } from "./HomeSocialProof.vue?vue&type=template&id=16483f4f"
import script from "./HomeSocialProof.vue?vue&type=script&lang=js"
export * from "./HomeSocialProof.vue?vue&type=script&lang=js"
import style0 from "./HomeSocialProof.vue?vue&type=style&index=0&id=16483f4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports